import { render, staticRenderFns } from "./SurgDotsMenu.vue?vue&type=template&id=2e103bea&scoped=true"
import script from "./SurgDotsMenu.vue?vue&type=script&lang=js"
export * from "./SurgDotsMenu.vue?vue&type=script&lang=js"
import style0 from "./SurgDotsMenu.vue?vue&type=style&index=0&id=2e103bea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e103bea",
  null
  
)

export default component.exports